import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=28ccc0ea&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
import style0 from "./Activity.vue?vue&type=style&index=0&id=28ccc0ea&prod&lang=scss&scoped=true"
import style1 from "./Activity.vue?vue&type=style&index=1&id=28ccc0ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ccc0ea",
  null
  
)

export default component.exports